import { z } from "zod";
import "../zod-runtime.js";
import { mapSchema } from "./map.js";
import { tacticSchema } from "./tactic.js";
import { utilitySchema } from "./utility.js";
export const snapshotPayloadSchema = z.object({
    maps: z.array(mapSchema),
    tactics: z.array(tacticSchema),
    utilities: z.array(utilitySchema),
});
export const publishedSnapshotSchema = z.object({
    revision: z.number().int().positive(),
    hash: z.string().regex(/^[a-f0-9]{64}$/),
    publishedAt: z.string().datetime(),
    payload: snapshotPayloadSchema,
    mediaHashes: z.array(z.string().regex(/^[a-f0-9]{64}$/)),
});
/** Kopfdaten der Historie — ohne die vollständige Payload jeder Revision. */
export const snapshotSummarySchema = z.object({
    revision: z.number().int().positive(),
    hash: z.string().regex(/^[a-f0-9]{64}$/),
    publishedAt: z.string().datetime(),
    tacticCount: z.number().int().min(0),
    active: z.boolean(),
});
